module.exports = __webpack_public_path__ + "img/logo.db4cc8b6.png";